<div class="h-100">

	<readonly-access [readonly]="!dialogDataService.canEdit() && !dialogDataService.canEditMentors()"></readonly-access>

	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
		[rows]="dialogDataService.dialogData()?.accTeamMentors ?? []"></grid-content>
</div>